import React from "react";
import AdminHeader from "../../../components/admin/AdminHeader";
import { AdminFooter } from "../../../components/admin/AdminFooter";
import AdminService from "../../../views/admin/cms/AdminService";

const AdminServicePage = () => {
  window.scrollTo(0, 0);

  return (
    <div>
      <AdminHeader />
        <AdminService />
      <AdminFooter />
    </div>
  );
};

export default AdminServicePage;
